import React from 'react';

const defaultService = null;
export default React.createContext(defaultService);
